import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import SessionRPE from "./session-rpe/SessionRPE";
import _ from "lodash";
import { isAdminOrOwner } from "../../../utils/organization-permissions-helpers";

const SessionRPEController = (app) => {
  app.get("/session-rpe", async ({ req, res, locals, load }) => {
    const isAllowToViewAllOrganizationsAthletes = isAdminOrOwner(
      locals.organizationRoleName
    );

    if (
      locals.activeUser.organizationId &&
      isAllowToViewAllOrganizationsAthletes &&
      !locals.allAthletesFromOrganization
    ) {
      await load("allAthletesFromOrganization");
    }
    const modal = _.get(req.query, "modal", {});
    locals.modal = {
      "activity-feed": <ActivityDrawer />,
    }[modal.type];
    res.body = <SessionRPE />;
  });
};

export default SessionRPEController;
